// コンバート詳細モーダル
const ModalConvertDetail = {
  namespaced: true,

  state: {
    modal: false,
    resultId: null,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getResultId: state => {
      return state.resultId
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setResultId(state, resultId) {
      state.resultId = resultId
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setResultId', item.resultId)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setResultId', null)
    },
  },
}

export default ModalConvertDetail
